import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_CONTROLLER, SOCIETY_MANAGE_TENANTS } from '../../../Routing/routes';
import ManageTenantListLayer from './Component/ManageTenantListLayer';

const ManageTenant = () => {
    const links = [
        { to: SOCIETY_CONTROLLER, text: 'Dashboard' },
        { to: SOCIETY_MANAGE_TENANTS, text: 'Manage Tenants' }
    ];

    return (
        <>
            <Breadcrumb
                description='View and manage all tenants in the system'
                links={links}
                headingTitle="Manage Tenant"
            />
            <ManageTenantListLayer />
        </>
    );
};

export default ManageTenant;
